module.exports = __webpack_public_path__ + "static/img/LogoLogin.a4d36aa7.png";